import { useState } from "react";
import { Stack, Typography } from "@mui/material";
import useDebtSalesHistoryTab from "../../hooks/useDebtSalesHistoryTab";
import TableComp from "src/components/shared/table/TableComp";
import DebtSalesFilter from "../../components/DebtSalesFilter";
import { DebtSalesHistoryDetailDialog } from "../Dialogs";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";

const DebtSalesHistoryTab = ({ date }) => {
  const [paramsQuery, setParamsQuery] = useState({});
  const { bodyList, sortData, header, pagi, setPagi, total, footerTotals, setSelectedRow, selectedRow } = useDebtSalesHistoryTab({ date, paramsQuery });

  const handleCloseDetail = () => {
    setSelectedRow(null);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        my="14px"
      >
        <DebtSalesFilter
          variant="history"
          setParamsQuery={setParamsQuery}
          paramsQuery={paramsQuery}
        />
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        total={total}
        pagi={pagi}
        noBackground
        TableFooterComponent={
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={4}
            sx={{ py: 2, borderTop: "1px solid var(--grey)" }}
          >
            <Typography fontWeight="bold">Tổng:</Typography>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{ textAlign: "center" }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.all >= 0 ? "+" : ""}
                {formatCurrency(footerTotals?.all)}
              </Typography>
              <Typography
                color="#989898"
                fontSize="8px"
                fontStyle="italic"
              >
                {convertCurrency(footerTotals?.all ?? 0)} đồng
              </Typography>
            </Stack>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{ textAlign: "center" }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.paid > 0 ? "-" : "+"}
                {formatCurrency(Math.abs(footerTotals?.paid))}
              </Typography>
              <Typography
                color="#989898"
                fontSize="8px"
                fontStyle="italic"
              >
                {convertCurrency(footerTotals?.paid ?? 0)} đồng
              </Typography>
            </Stack>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{ textAlign: "center" }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.unpaid < 0 ? "-" : "+"}
                {formatCurrency(Math.abs(footerTotals?.unpaid))}
              </Typography>
              <Typography
                color="#989898"
                fontSize="8px"
                fontStyle="italic"
              >
                {convertCurrency(footerTotals?.unpaid ?? 0)} đồng
              </Typography>
            </Stack>
          </Stack>
        }
      />
      <DebtSalesHistoryDetailDialog
        open={!!selectedRow}
        onClose={handleCloseDetail}
        selectedRow={selectedRow}
      />
    </>
  );
};

export default DebtSalesHistoryTab;
